import * as getPrimaryDashboardActions from './get-primary-dashboard/actions';
import * as setPrimaryDashboardActions from './set-primary-dashboard/actions';

export default {
    ...getPrimaryDashboardActions,
    ...setPrimaryDashboardActions,
};
